module.exports = __webpack_public_path__ + "img/process_2.b2c94f7f.svg";